import { DS } from "../../theme-default";

export const styles = {
    defaultDialogStyles: {
        width: 'min(96vw, 1560px)',
        height: 'auto',
        minHeight: '0',
        maxHeight: 'calc(100vh - 72px)',
        position: 'fixed',
        top: '56px',
        left: '50%',
        marginTop: '0',
        marginLeft: 'calc(min(48vw, 780px) * -1)',
        backgroundColor: DS.surface,
        border: `1px solid ${DS.border}`,
        borderRadius: DS.radiusCard,
        zIndex: 1400,
        padding: '20px 24px 24px',
        boxShadow: DS.shadowOverlay,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch'
    },
    sidebarMenuItem: {
        sidebar: {
            width: 256,
            height: '100%',
        },
        sidebarLink: {
            display: 'block',
            padding: '16px 0px',
            color: DS.ink,
            textDecoration: 'none',
        },
        divider: {
            margin: '8px 0',
            height: 1,
            backgroundColor: DS.border,
        },
        content: {
            padding: '16px',
            height: '100%',
            backgroundColor: DS.surface,
        }
    }
};
